import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { t } = useLang();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="grid min-h-[60vh] place-items-center text-ppc-muted">{t("loading")}</div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
};
